// extracted by mini-css-extract-plugin
export default {"container":"BotaoProgresso_container__Sebur","bar":"BotaoProgresso_bar__tlj-C","linear":"BotaoProgresso_linear__fz+Kg","label":"BotaoProgresso_label__YGZVG"};